interface Env {
  ENV_NAME: string;
  APP_NAME: string;
  NEXT_PUBLIC_ENV_NAME: string;
  NEXT_PUBLIC_GA_MEASUREMENT_ID: string;
  NEXT_PUBLIC_URL: string;
  PGSQL_USER: string;
  PGSQL_PASSWORD: string;
  PGSQL_HOST: string;
  PGSQL_PORT: number;
  METERCUBE_DB: string;
  PGSQL_POOL_MAX: string;
  PGSQL_POOL_IDLE_TIMEOUT_MS: string;
  PGSQL_POOL_CONNECTION_TIMEOUT_MS: string;
  NEXTAUTH_SECRET: string;
  TICKET_UPLOAD_TOKEN_SECRET: string;
  SENDGRID_API_KEY: string;
  SENDGRID_EMAIL_VERIFICATION: string;
  SENDGRID_EMAIL_RESET_PASSWORD: string;
  SENDGRID_EMAIL_RESEARCH_CONTACT_FORM: string;
  SENDGRID_EMAIL_CONTACT_US_FORM: string;
  SENDGRID_EMAIL_BRAND_REPORTS_REQUEST: string;
  SENDGRID_EMAIL_BRAND_REPORTS_INVOICE: string;
  SENDGRID_EMAIL_BRAND_REQUESTS: string;
  SENDGRID_EMAIL_INVITATION: string;
  SENDGRID_EMAIL_EXPORT_READY: string;
  SENDGRID_EMAIL_EXPORT_FAILED: string;
  AUTH_EMAIL_SENDER: string;
  // CLOUDWATCH_LOGGROUP: string;
  // CLOUDWATCH_LOGSTREAM: string;
  REGION: string;
  ACCESS_KEY_ID: string;
  ACCESS_KEY_SECRET: string;
  PUBLIC_IMAGE_BUCKET: string;
  PRIVATE_BUCKET: string;
  S3_OBJECT_EXPIRATION: string;
  CUBEASIA_INFO_EMAIL: string;
  STRIPE_SECRET_KEY: string;
  GA_MEASUREMENT_ID: string;
  API_RATE_LIMIT: string;
  TOTP_ENCRYPTION_KEY: string;
  SNOWFLAKE_AUTH_METHOD: string;
  SNOWFLAKE_ACCOUNT: string;
  SNOWFLAKE_USERNAME: string;
  SNOWFLAKE_AUTHENTICATOR: string;
  SNOWFLAKE_WAREHOUSE: string;
  SNOWFLAKE_DATABASE: string;
  SNOWFLAKE_SCHEMA: string;
  SNOWFLAKE_ROLE: string;
  SNOWFLAKE_PRIVATE_KEY: string;
  SNOWFLAKE_KEEP_ALIVE_HEARTBEAT_SECONDS: string;
  SNOWFLAKE_LOG_LEVEL: string;
  WORDPRESS_GRAPHQL_ENDPOINT: string;
  SNOWFLAKE_DATABASE_KEYWORD: string;
  SNOWFLAKE_DATABASE_BANNER: string;
  SNOWFLAKE_DATABASE_PRICE_TRACKING: string;
  SNOWFLAKE_POOL_MIN: string;
  SNOWFLAKE_POOL_MAX: string;
  SNOWFLAKE_POOL_IDLE_TIMEOUT_MS: string;
  SNOWFLAKE_POOL_MAX_LIFETIME_MS: string;
  SNOWFLAKE_POOL_ACQUIRE_TIMEOUT_MS: string;
  SNOWFLAKE_DEBUG_SQL: string;
  SNOWFLAKE_STREAM_HEAP_CHECK_INTERVAL: string;
  SNOWFLAKE_STREAM_HEAP_LIMIT_MB: string;
  SNOWFLAKE_STREAM_STATEMENT_TIMEOUT_SECONDS: string;
  DS_ALERT_DISABLED: string;
  DS_ALERT_POLL_INTERVAL_MS: string;
  DS_ALERT_WORKER_DAILY_CRON: string;
  DS_ALERT_MAX_RSS_MB: string;
  DS_ALERT_WORKER_MAX_ATTEMPT: string;
  DS_ALERT_STALE_PROCESSING_MS: string;
  DS_ALERT_STALE_CHECK_INTERVAL_MS: string;
}

let envPromise: Promise<Env> | null = null;

export async function initEnvConfig(): Promise<Env> {
  try {
    return {
      ENV_NAME: process.env.ENV_NAME || '',
      APP_NAME: process.env.APP_NAME || '',
      NEXT_PUBLIC_ENV_NAME: process.env.NEXT_PUBLIC_ENV_NAME || '',
      NEXT_PUBLIC_GA_MEASUREMENT_ID:
        process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '',
      NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL || '',
      PGSQL_USER: process.env.PGSQL_USER || '',
      PGSQL_PASSWORD: process.env.PGSQL_PASSWORD || '',
      PGSQL_HOST: process.env.PGSQL_HOST || '',
      PGSQL_PORT: parseInt(process.env.PGSQL_PORT!) || 5432,
      METERCUBE_DB: process.env.METERCUBE_DB || '',
      PGSQL_POOL_MAX: process.env.PGSQL_POOL_MAX || '',
      PGSQL_POOL_IDLE_TIMEOUT_MS: process.env.PGSQL_POOL_IDLE_TIMEOUT_MS || '',
      PGSQL_POOL_CONNECTION_TIMEOUT_MS:
        process.env.PGSQL_POOL_CONNECTION_TIMEOUT_MS || '',
      NEXTAUTH_SECRET: process.env.NEXTAUTH_SECRET || '',
      TICKET_UPLOAD_TOKEN_SECRET: process.env.TICKET_UPLOAD_TOKEN_SECRET || '',
      SENDGRID_API_KEY: process.env.SENDGRID_API_KEY || '',
      SENDGRID_EMAIL_VERIFICATION:
        process.env.SENDGRID_EMAIL_VERIFICATION || '',
      SENDGRID_EMAIL_RESET_PASSWORD:
        process.env.SENDGRID_EMAIL_RESET_PASSWORD || '',
      SENDGRID_EMAIL_RESEARCH_CONTACT_FORM:
        process.env.SENDGRID_EMAIL_RESEARCH_CONTACT_FORM || '',
      SENDGRID_EMAIL_CONTACT_US_FORM:
        process.env.SENDGRID_EMAIL_CONTACT_US_FORM || '',
      SENDGRID_EMAIL_BRAND_REPORTS_REQUEST:
        process.env.SENDGRID_EMAIL_BRAND_REPORTS_REQUEST || '',
      SENDGRID_EMAIL_BRAND_REPORTS_INVOICE:
        process.env.SENDGRID_EMAIL_BRAND_REPORTS_INVOICE || '',
      SENDGRID_EMAIL_BRAND_REQUESTS:
        process.env.SENDGRID_EMAIL_BRAND_REQUESTS || '',
      SENDGRID_EMAIL_INVITATION: process.env.SENDGRID_EMAIL_INVITATION || '',
      SENDGRID_EMAIL_EXPORT_READY:
        process.env.SENDGRID_EMAIL_EXPORT_READY || '',
      SENDGRID_EMAIL_EXPORT_FAILED:
        process.env.SENDGRID_EMAIL_EXPORT_FAILED || '',
      AUTH_EMAIL_SENDER: process.env.AUTH_EMAIL_SENDER || '',
      // CLOUDWATCH_LOGGROUP: process.env.CLOUDWATCH_LOGGROUP || '',
      // CLOUDWATCH_LOGSTREAM: process.env.CLOUDWATCH_LOGSTREAM || '',
      REGION: process.env.REGION || 'ap-southeast-1',
      ACCESS_KEY_ID: process.env.ACCESS_KEY_ID || '',
      ACCESS_KEY_SECRET: process.env.ACCESS_KEY_SECRET || '',
      PUBLIC_IMAGE_BUCKET: process.env.PUBLIC_IMAGE_BUCKET || '',
      PRIVATE_BUCKET: process.env.PRIVATE_BUCKET || '',
      S3_OBJECT_EXPIRATION: process.env.S3_OBJECT_EXPIRATION || '',
      CUBEASIA_INFO_EMAIL: process.env.CUBEASIA_INFO_EMAIL || '',
      GA_MEASUREMENT_ID: process.env.GA_MEASUREMENT_ID || '',
      API_RATE_LIMIT: process.env.API_RATE_LIMIT || '',
      STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY || '',
      TOTP_ENCRYPTION_KEY: process.env.TOTP_ENCRYPTION_KEY || '',
      SNOWFLAKE_AUTH_METHOD: process.env.SNOWFLAKE_AUTH_METHOD || '',
      SNOWFLAKE_ACCOUNT: process.env.SNOWFLAKE_ACCOUNT || '',
      SNOWFLAKE_USERNAME: process.env.SNOWFLAKE_USERNAME || '',
      SNOWFLAKE_AUTHENTICATOR: process.env.SNOWFLAKE_AUTHENTICATOR || '',
      SNOWFLAKE_WAREHOUSE: process.env.SNOWFLAKE_WAREHOUSE || '',
      SNOWFLAKE_DATABASE: process.env.SNOWFLAKE_DATABASE || '',
      SNOWFLAKE_SCHEMA: process.env.SNOWFLAKE_SCHEMA || '',
      SNOWFLAKE_ROLE: process.env.SNOWFLAKE_ROLE || '',
      SNOWFLAKE_PRIVATE_KEY: process.env.SNOWFLAKE_PRIVATE_KEY || '',
      SNOWFLAKE_KEEP_ALIVE_HEARTBEAT_SECONDS:
        process.env.SNOWFLAKE_KEEP_ALIVE_HEARTBEAT_SECONDS || '',
      SNOWFLAKE_LOG_LEVEL: process.env.SNOWFLAKE_LOG_LEVEL || '',
      WORDPRESS_GRAPHQL_ENDPOINT: process.env.WORDPRESS_GRAPHQL_ENDPOINT || '',
      SNOWFLAKE_DATABASE_KEYWORD: process.env.SNOWFLAKE_DATABASE_KEYWORD || '',
      SNOWFLAKE_DATABASE_BANNER: process.env.SNOWFLAKE_DATABASE_BANNER || '',
      SNOWFLAKE_DATABASE_PRICE_TRACKING:
        process.env.SNOWFLAKE_DATABASE_PRICE_TRACKING || '',
      SNOWFLAKE_POOL_MIN: process.env.SNOWFLAKE_POOL_MIN || '',
      SNOWFLAKE_POOL_MAX: process.env.SNOWFLAKE_POOL_MAX || '',
      SNOWFLAKE_POOL_IDLE_TIMEOUT_MS:
        process.env.SNOWFLAKE_POOL_IDLE_TIMEOUT_MS || '',
      SNOWFLAKE_POOL_MAX_LIFETIME_MS:
        process.env.SNOWFLAKE_POOL_MAX_LIFETIME_MS || '',
      SNOWFLAKE_POOL_ACQUIRE_TIMEOUT_MS:
        process.env.SNOWFLAKE_POOL_ACQUIRE_TIMEOUT_MS || '',
      SNOWFLAKE_DEBUG_SQL: process.env.SNOWFLAKE_DEBUG_SQL || '',
      SNOWFLAKE_STREAM_HEAP_CHECK_INTERVAL:
        process.env.SNOWFLAKE_STREAM_HEAP_CHECK_INTERVAL || '',
      SNOWFLAKE_STREAM_HEAP_LIMIT_MB:
        process.env.SNOWFLAKE_STREAM_HEAP_LIMIT_MB || '',
      SNOWFLAKE_STREAM_STATEMENT_TIMEOUT_SECONDS:
        process.env.SNOWFLAKE_STREAM_STATEMENT_TIMEOUT_SECONDS || '',
      DS_ALERT_DISABLED: process.env.DS_ALERT_DISABLED || '',
      DS_ALERT_POLL_INTERVAL_MS: process.env.DS_ALERT_POLL_INTERVAL_MS || '',
      DS_ALERT_WORKER_DAILY_CRON: process.env.DS_ALERT_WORKER_DAILY_CRON || '',
      DS_ALERT_MAX_RSS_MB: process.env.DS_ALERT_MAX_RSS_MB || '',
      DS_ALERT_WORKER_MAX_ATTEMPT:
        process.env.DS_ALERT_WORKER_MAX_ATTEMPT || '',
      DS_ALERT_STALE_PROCESSING_MS:
        process.env.DS_ALERT_STALE_PROCESSING_MS || '',
      DS_ALERT_STALE_CHECK_INTERVAL_MS:
        process.env.DS_ALERT_STALE_CHECK_INTERVAL_MS || '',
    };
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function getEnvConfig(): Promise<Env> {
  try {
    if (!envPromise) {
      envPromise = initEnvConfig();
    }
    return envPromise;
  } catch (error: any) {
    // throw new Error(error);
    const message =
      typeof error === 'string'
        ? error
        : error?.message || JSON.stringify(error);
    throw new Error(`getSSMValues failed: ${message}`);
  }
}
